// extracted by mini-css-extract-plugin
module.exports = {"code-font":"api-explorer-endpoint-heading_code-font__1GwAs","endpoint-desc":"api-explorer-endpoint-heading_endpoint-desc__qULU3","link":"api-explorer-endpoint-heading_link__o_th_"};